module.exports = __webpack_public_path__ + "img/模板管理.6410f41e.png";